import { Box, Link } from "@mui/material";
import { WhatsApp } from "@mui/icons-material";
import { LG } from "../styles/liquidGlass";
import { useTiendaInfo } from "../contexts/TiendaInfoContext";
import { useTemplateConfig } from "../templates/templateConfigContext";

export default function WhatsAppButton() {
    const tiendaInfo = useTiendaInfo();
    const { config } = useTemplateConfig();

    const phone = tiendaInfo?.whatsappNumero?.replace(/\D/g, "") ?? "";
    const habilitado = tiendaInfo?.whatsappHabilitado ?? false;
    const mensaje = config.identidad.vchWhatsappMensaje || "Hola, quiero solicitar información.";

    if (!habilitado || !phone) return null;

    const href = `https://wa.me/${phone}?text=${encodeURIComponent(mensaje)}`;

    return (
        <Link href={href} target="_blank" rel="noopener noreferrer" sx={{ textDecoration: "none" }}>
            <Box
                sx={{
                    position: "fixed",
                    bottom: 20,
                    right: 20,
                    width: 48,
                    height: 48,
                    borderRadius: LG.radius.pill,
                    background: LG.color.buttonDark,
                    backdropFilter: LG.blur,
                    WebkitBackdropFilter: LG.blur,
                    border: `1px solid ${LG.color.border}`,
                    boxShadow: LG.shadow.lg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1500,
                    transition: LG.transition,
                    cursor: "pointer",
                    "&:hover": {
                        transform: "scale(1.08)",
                        boxShadow: LG.shadow.xl,
                    },
                }}
            >
                <WhatsApp sx={{ fontSize: 22, color: LG.color.buttonDarkText }} />
            </Box>
        </Link>
    );
}
